import { render, staticRenderFns } from "./mobile_studio.vue?vue&type=template&id=10dd3ef9&scoped=true"
import script from "./mobile_studio.vue?vue&type=script&lang=js"
export * from "./mobile_studio.vue?vue&type=script&lang=js"
import style0 from "./mobile_studio.vue?vue&type=style&index=0&id=10dd3ef9&prod&lang=scss"
import style1 from "./mobile_studio.vue?vue&type=style&index=1&id=10dd3ef9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd3ef9",
  null
  
)

export default component.exports